import styled from 'styled-components';

export const CopyContainer = styled.div`
  margin: 2em 0;
`;
